module.exports = __webpack_public_path__ + "img/table.18688572.png";